<template>
    <div
      v-if="showTaskEditModal"
      class="modal-overlay"
      @click="$store.commit('setShowTaskEditModal', false)">
      <div class="modal-content" @click.stop>
        <h2>Edit Task Details</h2>
        <div class="d-flex ">
            <div class="d-flex gap-1-rem flex-direction-column w-100">
                <div class="d-flex gap-1-rem w-100 flex-direction-column">
                    <span class="d-flex label w-100 ">Task Name</span>
                    <input type="text" v-model="localTaskCopy.name">        
                </div>
                <div class="d-flex gap-5 flex-direction-column">
                  <span class="d-flex label w-100 ">Description</span>
                  <div class="textarea-background">
                      <textarea
                      name="task-name"
                      placeholder="Task Description."
                      v-model="localTaskCopy.description"
                      rows="2"
                      ></textarea>
                  </div>
                </div>
                <div class="d-flex w-100">
                  <!-- <div class="d-flex input-div ">
                    <span class="d-flex label w-100 ">Project</span>
                    <select class="w-100" name="project" v-model="activeTask.project_id" id="">
                      <option v-for="project in projects" :value="project.id" :key="project.id">{{project.name}}</option>
                    </select>
                  </div> -->
                  <div class="d-flex input-div ">
                    <span class="d-flex label w-100 ">Goal</span>
                    <select class="w-100" name="project" v-model="localTaskCopy.goal_id" id="">
                      <option v-for="goal in goals" :value="goal.id" :key="goal.id">{{goal.goal}}</option>
                    </select>
                  </div>
                  <div class="input-div">
                    <span class="d-flex label w-100">Due Date</span>
                    <DateTimePicker v-model:datetime="formattedDueDate" />

                    <input type="datetime-local" v-model="formattedDueDate"/>
                  </div>
                </div>
                <div class="d-flex gap-5 justify-content-end">
                    <button @click.prevent="$store.commit('setShowTaskEditModal', false)" class="secondary add-task-button">Cancel</button>
                    <button @click.prevent="editTask()" class="primary add-task-button">Update</button>
                </div>
            </div>
        </div>
      </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DateTimePicker from '@/components/helper/DateTimePicker.vue';

export default {
name: "EditTaskModal", 
  props: {

  },
  components: {
    DateTimePicker
  },
  computed: {
    localTaskCopy: {
    get() {
      // Automatically retrieve `activeTask` and provide a default object if null
      return { ...this.activeTask }; 
    },
   
    },
    formattedDueDate: {
      get() {
        // Convert ISO format to `YYYY-MM-DDTHH:MM` for the input
        return this.activeTask.due_date
          ? new Date(this.activeTask.due_date).toISOString().slice(0, 16) // Keeps input compatible
          : '';
      },
      set(value) {
        // Convert `datetime-local` format to `YYYY-MM-DD HH:MM:SS` (MySQL format)
        const date = new Date(value);
        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date
          .getHours()
          .toString()
          .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:00`;

        this.localTaskCopy.due_date = formattedDate; // Save in MySQL-compatible format
      },
    },
  ...mapGetters(['selectedProject','showTaskEditModal','activeTask','goals']), // Access Vuex state via getter
  },
  data() {
  return {
    };
  },
  mounted(){

  },
  methods: {
    editTask(){
      this.$store.dispatch('editTask', {showModal: false, task: this.localTaskCopy})
    },
    formatFileSize(sizeInBytes) {
      if (sizeInBytes === 0) return '0 Bytes';
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
      const formattedSize = (sizeInBytes / Math.pow(1024, i)).toFixed(2);
      return `${formattedSize} ${sizes[i]}`;
    },
    styalizeRadio(){
      if(this.localTaskCopy.date_completed){
          return "radio-button-checked";
      }else{
        return "radio-button";
      }
    },
  
    taskNameClass(){
        let className= "goal-name";
        if(this.localTaskCopy.date_completed){
          className += " strike";
        }
        return className
    }, 
  },
};
</script>


<style scoped>
 .input-div {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 5px;
  padding: 5px;
}

/* Textarea overflow */
textarea {
  overflow-y: visible !important;
}


.check-icon {
  stroke: var(--white-color);
}
.check-icon-hidden {
  display: none;
}
/* On hover, show the check icon */
.radio-button:hover .check-icon {
  display: block;
}

/* Modal Header & Description */
h2 {
  margin-bottom: 1rem;
}
.modal-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.modal-header-description {
  font-family: var(--body-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--dark-colo-a0);
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex; 
  justify-content: center; 
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  background: var(--Theme-Color-Secondary-Black);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 90%;
  display: flex;
  flex-direction: column;
}
.modal-content h2 {
  margin-top: 0;
  font-size: 20px;
  color: var(--white-color);
}

/* Modal Actions */
.modal-actions {
  display: flex; 
  justify-content: flex-end; 
  gap: 10px; 
  margin-top: 20px;
}
.modal-actions .secondary,
.modal-actions .primary {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

</style>